import { render, staticRenderFns } from "./auth_error.vue?vue&type=template&id=3ca64b86&"
import script from "./auth_error.vue?vue&type=script&lang=js&"
export * from "./auth_error.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports